module.exports = "/images/ifrc-logo.png?efe1fd5908750591325b4f06d7d70311";